import { useEffect, useMemo, useState } from 'react';

import './Spots.css';

const blobStyles = [
    {
        width: 42,
        height: 46,
        background: 'radial-gradient(circle at 58% 42%, rgba(58, 149, 255, .96) 0%, rgba(18, 77, 255, .82) 34%, rgba(2, 13, 139, .38) 62%, transparent 78%)',
        borderRadius: '58% 42% 63% 37% / 46% 57% 43% 54%',
        x: -18,
        y: -4,
    },
    {
        width: 38,
        height: 38,
        background: 'radial-gradient(circle at 45% 48%, rgba(51, 160, 255, .95) 0%, rgba(31, 132, 255, .72) 38%, rgba(31, 72, 255, .24) 66%, transparent 80%)',
        borderRadius: '43% 57% 38% 62% / 61% 39% 58% 42%',
        x: 7,
        y: 5,
    },
    {
        width: 31,
        height: 29,
        background: 'radial-gradient(circle at 50% 50%, rgba(170, 89, 255, .78) 0%, rgba(91, 24, 164, .58) 38%, rgba(51, 0, 71, .26) 68%, transparent 82%)',
        borderRadius: '67% 33% 54% 46% / 39% 63% 37% 61%',
        x: -4,
        y: 16,
    },
    {
        width: 26,
        height: 24,
        background: 'radial-gradient(circle at 50% 50%, rgba(255,255,255,.55) 0%, rgba(111, 188, 255, .34) 42%, rgba(255,255,255,0) 76%)',
        borderRadius: '36% 64% 41% 59% / 56% 38% 62% 44%',
        x: 12,
        y: -10,
    },
];

const Spots = ({
    spots = [],
    top,
    left,
    right,
    bottom,
    spotDelay = 0,
    className = '',
}) => {
    const [viewportWidth, setViewportWidth] = useState(() =>
        typeof window === 'undefined' ? 1440 : window.innerWidth
    );

    useEffect(() => {
        const handleResize = () => setViewportWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const scale = useMemo(
        () => (viewportWidth >= 1400 ? 1 : Math.max(0.5, viewportWidth / 1400)),
        [viewportWidth]
    );

    const horizontalOffset = typeof left === 'number'
        ? left
        : typeof right === 'number'
            ? -right
            : 0;

    // Рисуем кляксы сразу, даже пока генератор готовит параметры анимации.
    const resolvedSpots = blobStyles.map((_, index) => spots[index] || ({
        id: `fallback-${index}`,
        rotation: index % 2 === 0 ? -12 - index * 3 : 10 + index * 4,
        duration: 14 + index * 3,
        delay: index * 1.35,
    }));

    return (
        <div
            className={`spots ${className}`.trim()}
            style={{
                position: 'absolute',
                top,
                bottom,
                left: '50%',
                width: 0,
                height: 0,
                transform: `translateX(${horizontalOffset}px)`,
            }}
        >
            <div className='spot'>
                {blobStyles.map((param, index) => {
                    const spotData = resolvedSpots[index];

                    return (
                        <span
                            key={spotData.id}
                            className={`spot__blob spot__blob--${index + 1}`}
                            style={{
                                '--blob-width': `${param.width * scale}rem`,
                                '--blob-height': `${param.height * scale}rem`,
                                '--blob-x': `${param.x * scale}rem`,
                                '--blob-y': `${param.y * scale}rem`,
                                '--blob-rotation': `${spotData.rotation}deg`,
                                '--blob-duration': `${spotData.duration}s`,
                                '--blob-delay': `${spotData.delay + spotDelay}s`,
                                '--blob-background': param.background,
                                '--blob-radius': param.borderRadius,
                                zIndex: index + 1,
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default Spots;
